import dispatchEvent from "./dispatchEvent";

// This method triggers a window "resize" event after each of its content image is loaded.
//
// This can safely be called multiple times as idempotence is handled by setting a DOM
// data-attribute to avoid triggering multiple times the resize event.
//
// It is mainly use to make image containers resize after all images are loaded, like
// carousels etc.
//
export default function resizeWindowOnContentImageLoad(container) {
  if (!container || !container.querySelectorAll) return;

  // Find all images that were not already processed by this component's
  // instance.
  const images = container.querySelectorAll("img:not([data-image-loaded])");

  Object.keys(images).forEach((key) => {
    const image = images[key];

    // If the element of the set is not a node pass to the next element
    if (!image || !image.setAttribute) return;

    // Flag the image as being already processed
    image.setAttribute("data-image-loaded", true);

    // Trigger a resize event that will make every nested withContentHeight
    // event handlers to force reprocessing their content height now that
    // the image height is known
    const loadingImage = new Image();
    image.onload = () => dispatchEvent(window, "resize");
    loadingImage.src = image.src;
  });
}
